var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.payroll.message.type") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseRadioRich", {
                    attrs: {
                      val: _vm.PAYSLIP_CONDITION_TYPE.BASIC,
                      label: _vm.$t("apps.payroll.message.radiotypebasic"),
                      message: _vm.$t(
                        "apps.payroll.message.radiotypebasicdetail"
                      ),
                      disabled: _vm.disabled || !!_vm.state
                    },
                    model: {
                      value: _vm.input.type,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "type", $$v)
                      },
                      expression: "input.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseRadioRich", {
                    attrs: {
                      val: _vm.PAYSLIP_CONDITION_TYPE.ADVANCED,
                      label: _vm.$t("apps.payroll.message.radiotypeadvanced"),
                      message: _vm.$t(
                        "apps.payroll.message.radiotypeadvanceddetail"
                      ),
                      disabled: _vm.disabled || !!_vm.state
                    },
                    model: {
                      value: _vm.input.type,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "type", $$v)
                      },
                      expression: "input.type"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.payroll.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.payroll.message.name") + " *" }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.name.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.name, "$model", $$v)
                      },
                      expression: "$v.input.name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: {
                      text:
                        _vm.$t("apps.payroll.message.calculationtype") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      classNames: [
                        { "is-invalid": _vm.$v.input.isIncrement.$error }
                      ],
                      options: _vm.calcOptions,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.isIncrement.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.isIncrement, "$model", $$v)
                      },
                      expression: "$v.input.isIncrement.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.input.type === _vm.PAYSLIP_CONDITION_TYPE.ADVANCED
        ? _c(
            "Section",
            { staticClass: "mb-4" },
            [
              _c("SectionHeader", {
                attrs: { title: _vm.$t("apps.payroll.message.condition") }
              }),
              _vm._v(" "),
              _c(
                "FormRow",
                [
                  _c(
                    "Col",
                    { attrs: { className: "col-lg-12" } },
                    [
                      _c("BasePayrollCondition", {
                        attrs: {
                          disabled: _vm.disabled,
                          valid: _vm.isConditionValid,
                          validateFormValue: _vm.validateFormValue,
                          validateFormIftrue: _vm.validateFormIFTrue,
                          validateFormIfFalse: _vm.validateFormIfFalse,
                          clearFormIfTrue: _vm.clearFormIfTrue,
                          clearFormIfFalse: _vm.clearFormIfFalse
                        },
                        on: {
                          "update:valid": function($event) {
                            _vm.isConditionValid = $event
                          },
                          "update:validateFormValue": function($event) {
                            _vm.validateFormValue = $event
                          },
                          "update:validate-form-value": function($event) {
                            _vm.validateFormValue = $event
                          },
                          "update:validateFormIftrue": function($event) {
                            _vm.validateFormIFTrue = $event
                          },
                          "update:validate-form-iftrue": function($event) {
                            _vm.validateFormIFTrue = $event
                          },
                          "update:validateFormIfFalse": function($event) {
                            _vm.validateFormIfFalse = $event
                          },
                          "update:validate-form-if-false": function($event) {
                            _vm.validateFormIfFalse = $event
                          },
                          "update:clearFormIfTrue": function($event) {
                            _vm.clearFormIfTrue = $event
                          },
                          "update:clear-form-if-true": function($event) {
                            _vm.clearFormIfTrue = $event
                          },
                          "update:clearFormIfFalse": function($event) {
                            _vm.clearFormIfFalse = $event
                          },
                          "update:clear-form-if-false": function($event) {
                            _vm.clearFormIfFalse = $event
                          }
                        },
                        model: {
                          value: _vm.input.condition,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "condition", $$v)
                          },
                          expression: "input.condition"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Section",
        { attrs: { className: "mt-3" } },
        [
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  _c("BaseCheckbox", {
                    attrs: {
                      label: _vm.$t("apps.payroll.label.autoapply"),
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.input.autoApplyNewEmp,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "autoApplyNewEmp", $$v)
                      },
                      expression: "input.autoApplyNewEmp"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ec2415a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ec2415a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/PayrollConditionForm.vue
// module id = null
// module chunks = 